<template>
  <main class="register-experience">
    <div class="register-grid" aria-hidden="true"></div>
    <router-link to="/" class="register-brand" aria-label="Voltar para a página inicial da Sanvault">
      <img src="../../assets/images/home/favicon.png" width="42" height="42" alt="">
      <span>Sanvault</span>
    </router-link>

    <section class="register-value">
      <div class="register-value__inner">
        <span class="register-kicker">
          <span></span>
          Governança de gravações + inteligência operacional
        </span>
        <h1>Comece a transformar suas ligações em dados pesquisáveis.</h1>
        <p>
          Centralize o histórico da sua operação, encontre o que foi dito e use
          transcrição, sentimento e métricas para trabalhar com mais contexto.
        </p>

        <div class="value-list">
          <article>
            <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
            <div>
              <h2>Encontre conversas em segundos</h2>
              <p>Pesquise por período, origem, arquivo, sentimento e conteúdo transcrito.</p>
            </div>
          </article>
          <article>
            <i class="ph ph-waveform" aria-hidden="true"></i>
            <div>
              <h2>Entenda o que foi falado</h2>
              <p>Transforme áudio em texto e acesse a gravação sempre que precisar.</p>
            </div>
          </article>
          <article>
            <i class="ph ph-chart-line-up" aria-hidden="true"></i>
            <div>
              <h2>Acompanhe sua operação</h2>
              <p>Visualize métricas de volume, duração e processamento das chamadas.</p>
            </div>
          </article>
        </div>

        <div class="register-support">
          <span>Prefere conhecer a plataforma antes?</span>
          <a
            href="https://wa.me/5511915100084?text=Ol%C3%A1!%20Quero%20conhecer%20a%20Sanvault%20e%20entender%20como%20transformar%20as%20grava%C3%A7%C3%B5es%20da%20minha%20opera%C3%A7%C3%A3o%20em%20dados%20pesquis%C3%A1veis."
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="ph ph-whatsapp-logo" aria-hidden="true"></i>
            Solicitar demonstração
          </a>
        </div>
      </div>
    </section>

    <section class="register-form-section" aria-labelledby="register-title">
      <div class="register-card">
        <div class="register-card__header">
          <span>Teste gratuito</span>
          <h2 id="register-title">Crie sua conta</h2>
          <p>Preencha os dados abaixo para começar.</p>
        </div>

        <form ref="formRegister" @submit.prevent="submitRegister">
          <div class="form-grid">
            <label class="field">
              <span>Nome</span>
              <input
                ref="name"
                type="text"
                name="name"
                autocomplete="name"
                placeholder="Seu nome completo"
                @keyup="changeInformationInputs('name')"
              >
            </label>

            <label class="field">
              <span>Celular</span>
              <input
                ref="cellphone"
                type="tel"
                name="cellphone"
                autocomplete="tel"
                inputmode="tel"
                placeholder="(00) 00000-0000"
                maxlength="15"
                @keyup="changeInformationInputs('cellphone')"
                @input="applyMaskPhone"
              >
            </label>

            <label class="field">
              <span>Telefone comercial</span>
              <input
                ref="commercial_phone"
                type="tel"
                name="commercial_phone"
                inputmode="tel"
                placeholder="(00) 00000-0000"
                maxlength="15"
                @keyup="changeInformationInputs('commercial_phone')"
                @input="applyMaskPhone"
              >
            </label>

            <label class="field">
              <span>CPF ou CNPJ</span>
              <input
                ref="cpf_cnpj"
                type="text"
                name="cpf_cnpj"
                inputmode="numeric"
                placeholder="Digite seu documento"
                maxlength="18"
                @keyup="changeInformationInputs('cpf_cnpj')"
                @input="applyMaskCpfCnpj"
              >
            </label>

            <label class="field field--full">
              <span>E-mail</span>
              <input
                ref="email"
                type="email"
                name="email"
                autocomplete="email"
                placeholder="voce@empresa.com.br"
                @keyup="changeInformationInputs('email')"
              >
            </label>

            <label class="field">
              <span>Senha</span>
              <input
                ref="password"
                type="password"
                name="password"
                autocomplete="new-password"
                placeholder="Crie uma senha segura"
                @keyup="changeInformationInputs('password')"
              >
            </label>

            <label class="field">
              <span>Confirme sua senha</span>
              <input
                ref="confirm_password"
                type="password"
                name="confirm_password"
                autocomplete="new-password"
                placeholder="Repita sua senha"
                @keyup="changeInformationInputs('confirm_password')"
              >
            </label>
          </div>

          <div ref="error_password_message" class="error-password-message" role="alert">
            As senhas são diferentes.
          </div>
          <div ref="error_password_message_caracters" class="error-password-message-caracters" role="alert">
            A senha precisa ter pelo menos um número e um caractere especial.
          </div>

          <p class="password-hint">
            Use pelo menos um número e um caractere especial.
          </p>

          <p class="terms-copy">
            Ao criar a conta, você concorda com os
            <a href="/terms" target="_blank" rel="noopener noreferrer">Termos de Uso</a>
            e a
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>.
          </p>

          <button ref="button_submit_register" class="register-submit" type="submit">
            Criar conta grátis
            <i class="ph ph-arrow-right" aria-hidden="true"></i>
          </button>

          <div v-if="getErrorRegister != ''" class="message-error-register" role="alert">
            {{ getErrorRegister }}
          </div>
        </form>

        <p class="login-copy">
          Já possui uma conta?
          <router-link to="/login">Entrar agora</router-link>
        </p>
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "RegisterContent",
  computed:{
    ...mapGetters([
      'getErrorRegister'
    ])
  },
  methods: {
    ...mapActions([
        "sendRegister"
    ]),
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskCpfCnpj(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 11) {
        value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      } else {
        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      input.value = value;
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    hasLetters(str) {
      return /[a-zA-Z]/.test(str);
    },
    validateCaractersInputs(data){
      data.cellphone = data.cellphone.replace(/[!@#$(.) /-]/g, "");
      data.commercial_phone = data.commercial_phone.replace(/[!@#$(.) /-]/g, "");
      data.cpf_cnpj = data.cpf_cnpj.replace(/[!@#$(.) /-]/g, "");

      return data;
    },
    checkPassword(password){
      return /[0-9]/.test(password) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/.test(password);
    },
    submitRegister(){
      const formData = new FormData(this.$refs['formRegister']);
      var data = {};
      for (let [key, val] of formData.entries()) {
        Object.assign(data, { [key]: val })
      }

      data = this.validateCaractersInputs(data);

      let error = false;
      if(data.name == ""){
        this.$refs["name"].style.borderColor = "red";
        error = true;
      }

      if(data.cellphone == "" || this.hasLetters(data.cellphone) || data.cellphone.length < 10){
        this.$refs["cellphone"].style.borderColor = "red";
        error = true;
      }
      
      if(data.commercial_phone == "" || this.hasLetters(data.commercial_phone) || data.commercial_phone.length < 10){
        this.$refs["commercial_phone"].style.borderColor = "red";
        error = true;
      }
      
      if(data.cpf_cnpj == "" || this.hasLetters(data.cpf_cnpj) || (data.cpf_cnpj.length != 11 && data.cpf_cnpj.length != 14)){
        this.$refs["cpf_cnpj"].style.borderColor = "red";
        error = true;
      }
      
      if(data.email == ""){
        this.$refs["email"].style.borderColor = "red";
        error = true;
      }
      
      if(data.password == ""){
        this.$refs["password"].style.borderColor = "red";
        error = true;
      }
      
      if(data.confirm_password == ""){
        this.$refs["confirm_password"].style.borderColor = "red";
        error = true;
      }

      if(data.password != data.confirm_password){
        this.$refs["password"].style.borderColor = "red";
        this.$refs["confirm_password"].style.borderColor = "red";
        this.$refs["error_password_message"].style.display = "flex";
        error = true;
      } else {
        this.$refs["error_password_message"].style.display = "none";
      }

      if(!this.checkPassword(data.password)){
        this.$refs["error_password_message_caracters"].style.display = "flex";
        error = true;
      } else {
        this.$refs["error_password_message_caracters"].style.display = "none";
      }

      if(error){
        return;
      }

      this.$refs.button_submit_register.innerHTML = "Carregando...";
      this.$refs.button_submit_register.disabled = true;

      this.sendRegister(data).then(() => {
        this.$refs.button_submit_register.innerHTML = "Criar conta";
        this.$refs.button_submit_register.disabled = false;
      });
    }
  }
};
</script>

<style scoped>
.register-experience {
  --navy-950: #061426;
  --navy-900: #0a1c33;
  --blue-600: #1d6ff2;
  --cyan-500: #20c7d9;
  --surface: #f5f8fc;
  --muted: #607089;
  position: relative;
  display: grid;
  grid-template-columns: minmax(420px, 0.9fr) minmax(580px, 1.1fr);
  min-height: 100vh;
  overflow: hidden;
  color: #10223b;
  background: var(--surface);
  font-family: "Red Hat Display", sans-serif;
}

.register-grid {
  position: absolute;
  inset: 0 50% 0 0;
  opacity: 0.24;
  background-image:
    linear-gradient(rgba(32, 199, 217, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(32, 199, 217, 0.1) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: linear-gradient(to bottom, transparent, black 20%, black 80%, transparent);
  pointer-events: none;
}

.register-brand {
  position: absolute;
  top: 30px;
  left: 40px;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-decoration: none;
}

.register-brand img {
  border-radius: 11px;
}

.register-value {
  position: relative;
  display: flex;
  align-items: center;
  padding: 118px 8vw 80px 5vw;
  color: #ffffff;
  background:
    radial-gradient(circle at 16% 80%, rgba(32, 199, 217, 0.15), transparent 27%),
    linear-gradient(145deg, var(--navy-950), #0b2447);
}

.register-value__inner {
  position: relative;
  z-index: 1;
  width: min(100%, 570px);
}

.register-kicker {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: var(--cyan-500);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.4;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.register-kicker span {
  width: 7px;
  height: 7px;
  background: var(--cyan-500);
  border-radius: 50%;
  box-shadow: 0 0 0 5px rgba(32, 199, 217, 0.12);
}

.register-value h1 {
  margin: 24px 0 18px;
  color: #ffffff;
  font-size: clamp(42px, 4.2vw, 62px);
  font-weight: 800;
  line-height: 1.06;
  letter-spacing: -0.055em;
}

.register-value__inner > p {
  max-width: 540px;
  margin: 0;
  color: #afbed1;
  font-size: 17px;
  line-height: 1.7;
}

.value-list {
  display: grid;
  gap: 13px;
  margin-top: 42px;
}

.value-list article {
  display: flex;
  gap: 15px;
  padding: 17px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 13px;
}

.value-list article > i {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 42px;
  height: 42px;
  color: var(--cyan-500);
  background: rgba(32, 199, 217, 0.08);
  border-radius: 10px;
  font-size: 22px;
}

.value-list h2 {
  margin: 1px 0 4px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 800;
}

.value-list p {
  margin: 0;
  color: #9eb0c7;
  font-size: 12px;
  line-height: 1.55;
}

.register-support {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 30px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.register-support span {
  color: #9eb0c7;
  font-size: 12px;
}

.register-support a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--cyan-500);
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}

.register-form-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 65px 5vw;
}

.register-card {
  width: min(100%, 690px);
  padding: 42px;
  background: #ffffff;
  border: 1px solid #dfe7f1;
  border-radius: 20px;
  box-shadow: 0 25px 70px rgba(17, 48, 86, 0.12);
}

.register-card__header {
  margin-bottom: 29px;
}

.register-card__header > span {
  color: var(--blue-600);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.register-card__header h2 {
  margin: 7px 0 6px;
  color: var(--navy-950);
  font-size: 34px;
  font-weight: 800;
  letter-spacing: -0.035em;
}

.register-card__header p {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.field {
  display: grid;
  gap: 8px;
}

.field--full {
  grid-column: 1 / -1;
}

.field > span {
  color: #34455c;
  font-size: 13px;
  font-weight: 800;
}

.field input {
  width: 100%;
  height: 50px;
  padding: 0 14px;
  color: #10223b;
  background: #f8faff;
  border: 1px solid #dce5ef;
  border-radius: 9px;
  outline: none;
  font: inherit;
  font-size: 14px;
}

.field input::placeholder {
  color: #9aa8ba;
}

.field input:focus {
  background: #ffffff;
  border-color: var(--blue-600);
  box-shadow: 0 0 0 4px rgba(29, 111, 242, 0.1);
}

.error-password-message,
.error-password-message-caracters {
  display: none;
  margin-top: 13px;
  padding: 10px 12px;
  color: #9d2432;
  background: #fff0f2;
  border: 1px solid #ffd7dc;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.password-hint,
.terms-copy {
  margin: 13px 0 0;
  color: #75849a;
  font-size: 12px;
  line-height: 1.55;
}

.terms-copy {
  margin-top: 20px;
}

.terms-copy a {
  color: var(--blue-600);
  font-weight: 800;
}

.register-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 100%;
  min-height: 52px;
  margin-top: 20px;
  color: #ffffff;
  background: var(--blue-600);
  border: 0;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 800;
  box-shadow: 0 13px 28px rgba(29, 111, 242, 0.23);
  transition: transform 0.2s ease, background 0.2s ease;
}

.register-submit:hover {
  background: #0c5ddb;
  transform: translateY(-1px);
}

.register-submit:disabled {
  cursor: wait;
  opacity: 0.65;
  transform: none;
}

.message-error-register {
  margin-top: 15px;
  padding: 11px 13px;
  color: #9d2432;
  background: #fff0f2;
  border: 1px solid #ffd7dc;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.login-copy {
  margin: 24px 0 0;
  color: #75849a;
  font-size: 13px;
  text-align: center;
}

.login-copy a {
  margin-left: 4px;
  color: var(--blue-600);
  font-weight: 800;
  text-decoration: none;
}

.register-experience :where(a, button, input):focus-visible {
  outline: 3px solid rgba(32, 199, 217, 0.65);
  outline-offset: 3px;
}

@media (max-width: 1080px) {
  .register-experience {
    grid-template-columns: 1fr;
  }

  .register-grid {
    inset: 0;
  }

  .register-value {
    padding: 130px 7vw 70px;
  }

  .register-value__inner {
    width: min(100%, 760px);
    margin: 0 auto;
  }

  .register-value h1 {
    max-width: 720px;
  }

  .value-list {
    grid-template-columns: repeat(3, 1fr);
  }

  .value-list article {
    align-items: flex-start;
  }

  .register-support {
    max-width: 620px;
  }

  .register-form-section {
    padding: 65px 20px 80px;
  }
}

@media (max-width: 760px) {
  .register-brand {
    top: 24px;
    left: 24px;
  }

  .register-value {
    padding: 108px 24px 55px;
  }

  .register-value h1 {
    font-size: clamp(39px, 11vw, 54px);
  }

  .value-list {
    grid-template-columns: 1fr;
  }

  .register-support {
    align-items: flex-start;
    flex-direction: column;
  }

  .register-form-section {
    padding: 36px 15px 60px;
  }

  .register-card {
    padding: 31px 24px;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .field--full {
    grid-column: auto;
  }
}

@media (max-width: 420px) {
  .register-value {
    padding-right: 18px;
    padding-left: 18px;
  }

  .register-kicker {
    align-items: flex-start;
    font-size: 10px;
  }

  .register-kicker span {
    flex: 0 0 auto;
    margin-top: 4px;
  }

  .register-card {
    padding: 28px 19px;
  }

  .register-card__header h2 {
    font-size: 30px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .register-submit {
    transition: none;
  }
}
</style>
